import type { SVGProps } from 'react';
import * as React from 'react';

const SvgRefreshCcw06 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    fill="none"
    height="100%"
    stroke="currentColor"
    strokeWidth={1.5}
    viewBox="0 0 24 24"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.547 19.767a8.49 8.49 0 0 0 7.703-.406A8.5 8.5 0 0 0 19.361 7.75l-.25-.433M4.638 16.25A8.5 8.5 0 0 1 15.453 4.233M2.493 16.334l2.732.732.732-2.732m12.086-4.668.732-2.732 2.732.732"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgRefreshCcw06;
